export default "https://cdn-static.gokick.com/assets/3cd141d05df56e6b81a0153ff619f4101846aa93/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";